export default __webpack_public_path__ + "static/media/qualityAssuranceTesting.9def285c.png";